import { ServicesContainer } from '@/services';
import { OpenBagEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, Commerce } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ProductListItem } from '../classes';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeCartOpenEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.OpenBag;
  commerce = { ... this.commerce, productListOpens: { value: 1 }, productListAdds: { value: 1} } as Commerce;

  constructor(event: OpenBagEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (event.meal) {
      this.productListItems = ProductListItem.getProductListItems(event.meal, store, services.order.isDelivery());
    }
  }
}
